import React, { Fragment, memo } from 'react' ;
import "./ExtractModal.css" ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownLong, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Skeleton } from '@mui/material';
import { STATUS } from '../../Constants';
import { CSVLink } from 'react-csv';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

const ExtractModal = memo( ({data , status ,closeModal }) => {

  // For Translate Website
  const {t} = useTranslation();

  return (
    <div className='extract-data-modal my-font'>
      <div className='extract-head' >
        <h2>{t('extractData')} </h2>
        <div className='btns'>
          <button className='xclose-btn'>
            {/*<CSVLink data={data.map((item)=>({FBID: item.FBID,Phone : item.Phone,birthdayyear :item.birthdayyear,country : item.country,education : item.education,first_name : item.first_name ,gender : item.gender,hometown:item.hometown,id : item.id,last_name:item.last_name,locale: item.locale,location: item.location,relationship:item.relationship, religion: item.religion ,work : item.work ,about_me: item.about_me ,}))} filename='Group Data' style={{width : "100%" , height : "100%"}} >
              <FontAwesomeIcon icon={faDownLong} />
            </CSVLink>*/}
            <CSVLink data={data} filename='Group Data' style={{width : "100%" , height : "100%"}} >
              <FontAwesomeIcon icon={faDownLong} />
            </CSVLink>
          </button>
          <button style={{margin : "0px 5px"}} onClick={closeModal} className='xclose-btn'>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
        
      </div>

      
 
      <div className='table'>
      
        <div className='row-head'>
          <div className='item'>{t('id')}</div>
          <div className='item'>{t('phone')}</div>
          <div className='item'>{t('name')} </div>
          <div className='item'>{t('gender')}</div>
          <div className='item'>{t('work')}</div>
          <div className='item'>{t('location')}</div>
        </div>
        
        <div className='table-body'>
          
          
          {
            status === STATUS.SUCCESS ? 
            data.length > 0 ? 
            data.map((item , idx)=>(
            <motion.div className='row' key={idx}
            initial={{
              opacity : 0 ,
              translateX : -50
            }}

            whileInView={{
              opacity : 1 , 
              translateX : 0
            }}
            >
              <div className='item' style={{width : "20%" , padding :"20px"}}>{item.fbid}</div>
              <div className='item' style={{width : "20%" , padding :"20px"}}>{item.phone}</div>
              <div className='item' style={{width : "20%" , padding :"20px"}}>{item.first_name} {item.last_name}</div>
              <div className='item' style={{width : "20%" , padding :"20px"}}>{item.gender}</div>
              <div className='item' style={{width : "20%" , padding :"20px"}}>{item.work}</div>
              <div className='item' style={{width : "20%" , padding :"20px"}}>{item.location}</div>
            </motion.div>
            ))
            :<h4>{t('noResult')}</h4>
            :""
          }


          {
            status === STATUS.LOADDING ? (
              <Fragment>
                <div className='row'>
                  <div className='item'> <Skeleton width={150} height={30}  /> </div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                </div>
                <div className='row'>
                  <div className='item'> <Skeleton width={150} height={40}  /> </div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                  <div className='item'><Skeleton width={150} height={40}  /></div>
                </div>
                <div className='row'>
                  <div className='item'> <Skeleton width={150} height={40}  style={{borderRadius :"7px"}} /> </div>
                  <div className='item'><Skeleton width={150} height={40}  style={{borderRadius :"7px"}} /></div>
                  <div className='item'><Skeleton width={150} height={40}  style={{borderRadius :"7px"}} /></div>
                  <div className='item'><Skeleton width={150} height={40}  style={{borderRadius :"7px"}} /></div>
                  <div className='item'><Skeleton width={150} height={40}  style={{borderRadius :"7px"}} /></div>
                  <div className='item'><Skeleton width={150} height={40}  style={{borderRadius :"7px"}} /></div>
                </div>
              
              </Fragment>

            ) :""
          }


        </div>

      </div>

    </div>
  )
})

export default ExtractModal
